var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-wrap"},[_c('div',{staticClass:"divider"},[_c('p',{staticClass:"chinese"},[_vm._v(_vm._s(_vm.chinese))]),_vm._v(" "),_c('p',{staticClass:"english"},[_vm._v(_vm._s(_vm.english))]),_vm._v(" "),_c('p',{staticClass:"lineLeft"}),_vm._v(" "),_c('p',{staticClass:"lineRight"})]),_vm._v(" "),_c('p',{staticClass:"block"})])
}
var staticRenderFns = []

export { render, staticRenderFns }